import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { EDIT_TENANT_MUTATION, GET_TENANT_DATA_BY_USER } from "../../graphQL/tenant_qry";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#0D47A1",
      color: "white",
      fontSize: 18,
      fontWeight: 700,
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    // "& .style--true": {
    //   backgroundColor: "#FFFFFF",
    // },
    // "& .style--false": {
    //   backgroundColor: "#E2EDF5", //#E3F2FD",
    // },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E2EDF5",
    },
    [`& .${gridClasses.row}.even:hover`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd:hover`]: {
      backgroundColor: "#E2EDF5",
    },
    [`& .${gridClasses.row}.even.Mui-selected`]: {
      backgroundColor: "#FFFFFF !important",
    },
    [`& .${gridClasses.row}.odd.Mui-selected`]: {
      backgroundColor: "#E2EDF5 !important",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function TenantSettings() {
  //const tenantName = localStorage.getItem("tenantName");
  //const tenantId = localStorage.getItem("tenantId"); 

  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState({
    name: "", 
    contactEmail: "",   
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [editAccess, setEditAccess] = useState(true);
  

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Configure Tenant"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true);}
      else {setEditAccess(false);}

      

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);
  
  const [tenantName, setTenantName] = useState(""); 
  const [contactEmail, setContactEmail] = useState(""); 
  const [alertMsg, setAlertMsg] = useState([]);
  const [tenantData, setTenantData] = useState([]);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [getUserTenantData] = useManualQuery(GET_TENANT_DATA_BY_USER, {
    fetchPolicy: "network-only",
  });

  const [editTenant] = useMutation(EDIT_TENANT_MUTATION, {
    awaitRefetchQueries: true,
  });  

  const getTenant = async () => {
      // Get tenant information
      const {
        loading: tenantDataLoading,
        error: tenantDataError,
        data: tenantData,
      } = await getUserTenantData();

      if (!tenantDataLoading && tenantData && tenantData.getUserTenantData) {        
        setTenantData(tenantData.getUserTenantData);        
        setTenantName(tenantData.getUserTenantData.name); 
        setContactEmail(tenantData.getUserTenantData.contactEmail);      
      }
      if (
        tenantDataError &&
        tenantDataError.graphQLErrors &&
        tenantDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
  };

  const handleTenantNameChange = e => {
    setTenantName(e.target.value);
  };

  const handleContactEmailChange = e => {
    //errors.contactEmail = "";
    setContactEmail(e.target.value);    
    //if (e.target.value.toString().trim() === "") {
    //  setErrorMsg({ ...errorMsg, contactEmail: "Contact Email cannot be blank." });    
   // } else {
      setErrorMsg({ ...errorMsg, contactEmail: "" });      
   // };
  };

  
  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTenant())();
  }, []);

  
  const onSubmit = async formData => {
    if (contactEmail.toString().trim() == "" || contactEmail == "")
    {
      setErrorMsg({ ...errorMsg, contactEmail: "Contact Email cannot be blank." });
      return;
    } 
      
    else
    {
        const { data, error } = await editTenant({
          variables: {
            name: formData.tenantName,
            contactEmail: contactEmail,
            tenantId: parseInt(tenantData.tenantId),
          },
        });
        if (
            error &&
            error.graphQLErrors &&
            error.graphQLErrors[0].message === "NameExists"
          ){
          console.log("Error", error, data);
          setAlertMsg({
            title: "Error",
            msg: "This name exists. Please enter another name.",
          });
        } else if (data && data.editTenant) {
          console.log("Success", data);
          localStorage.setItem("tenantName", data.editTenant.tenant.name);
          setAlertMsg({
            title: "Success",
            msg: "Tenant has been successfully updated.",
          });
        }
    }
  };
  
  if (loadContent)
    if (editAccess )
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: 'General Settings', link: null },
                              { label: 'Configure Tenant', link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Configure Tenant
            </Typography>
          </Box>
          <Divider />

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  autoFocus
                  fullWidth
                  label="Tenant Name"
                  margin="normal"
                  name="tenantName"
                  type="tenantName"
                  variant="outlined"
                  value={tenantName}
                  id="tenantName"
                  {...register("tenantName", { required: true })}
                  
                  onChange={handleTenantNameChange}
                />

                {errors.tenantName && errors.tenantName.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Tenant Name cannot be blank.
                  </FormHelperText>
                )}

                
              </Grid>              
            </Grid>

            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}                    
                    fullWidth
                    label="Contact Email"
                    margin="normal"
                    name="contactEmail"
                    type="contactEmail"
                    variant="outlined"
                    value={contactEmail}
                    id="contactEmail"
                    {...register("contactEmail", {                      
                      pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    })}
                    
                    onChange={handleContactEmailChange}
                  />

                  {errorMsg.contactEmail && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.contactEmail}
                  </FormHelperText>
                   )}

                  {errors.contactEmail && errors.contactEmail.type === "pattern" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Enter a correctly-formed email like myname@xyz.com
                      </FormHelperText>
                    </Box>
                  )}

                </Grid>
              </Grid>

            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
                
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/tenant/dashboard`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/tenant/dashboard`);
              }}
            />
          )}
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default TenantSettings;
